import { useFieldArray, UseFormReturn } from 'react-hook-form';
import { EventPanelFormType } from '@mark43/cad-api';
import { RangeFieldKey } from '../types';

/**
 * This clears whatever range value is currently hidden to the user so we don't save both.
 */
export function usePruneInvolvedPersonRangeValues(form: UseFormReturn<EventPanelFormType>) {
    const { fields: reportingParties } = useFieldArray({
        control: form.control,
        name: 'reportingParties',
    });
    const { fields: involvedPersons } = useFieldArray({
        control: form.control,
        name: 'involvedPersons',
    });

    function clearField(
        index: number,
        baseKey: 'reportingParties' | 'involvedPersons',
        valueFieldKey: RangeFieldKey,
        minFieldKey: RangeFieldKey,
        maxFieldKey: RangeFieldKey
    ) {
        const { isDirty: valDirty } = form.getFieldState(`${baseKey}.${index}.${valueFieldKey}`);
        const { isDirty: minDirty } = form.getFieldState(`${baseKey}.${index}.${minFieldKey}`);
        const { isDirty: maxDirty } = form.getFieldState(`${baseKey}.${index}.${maxFieldKey}`);
        const rangeDirty = minDirty || maxDirty;

        if (valDirty) {
            form.setValue(`${baseKey}.${index}.${minFieldKey}`, null);
            form.setValue(`${baseKey}.${index}.${maxFieldKey}`, null);
        } else if (rangeDirty) {
            form.setValue(`${baseKey}.${index}.${valueFieldKey}`, null);
        }
    }

    function clearRanges(
        people: typeof involvedPersons | typeof reportingParties,
        baseKey: 'reportingParties' | 'involvedPersons'
    ) {
        for (let i = 0; i < people.length; i++) {
            clearField(i, baseKey, 'height', 'heightMin', 'heightMax');
            clearField(i, baseKey, 'weight', 'weightMin', 'weightMax');
            clearField(i, baseKey, 'dateOfBirth', 'ageMin', 'ageMax');
        }
    }

    function fixAllRanges() {
        clearRanges(involvedPersons, 'involvedPersons');
        clearRanges(reportingParties, 'reportingParties');
    }

    return { fixAllRanges };
}
